import React from 'react';
import { NavLink } from 'react-router-dom';
import {
  EnvelopeIcon,
  InboxIcon,
  UserCircleIcon,
} from '@heroicons/react/24/outline';

const linkClass = ({ isActive }) =>
  `flex items-center gap-2 px-3 py-2 rounded-lg text-xs font-medium transition-colors ${
    isActive
      ? 'bg-blue-50 dark:bg-blue-900/30 text-blue-800 dark:text-blue-200 border border-blue-200 dark:border-blue-800'
      : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 border border-transparent'
  }`;

const MailSidebar = () => {
  return (
    <aside className="w-56 shrink-0 min-h-0 h-full self-stretch border-r border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 flex flex-col">
      <div className="p-4 border-b border-gray-200 dark:border-gray-700 shrink-0">
        <h2 className="text-sm font-semibold text-gray-900 dark:text-white">Microsoft 365</h2>
        <p className="text-[11px] text-gray-500 dark:text-gray-400 mt-0.5">E-posta</p>
      </div>
      <nav className="p-2 space-y-1 flex-1 min-h-0 overflow-y-auto">
        <NavLink to="/mail/summary" end className={linkClass}>
          <EnvelopeIcon className="w-4 h-4 shrink-0" />
          AI özet
        </NavLink>
        <NavLink to="/mail/inbox" className={linkClass}>
          <InboxIcon className="w-4 h-4 shrink-0" />
          Gelen kutusu
        </NavLink>
        <NavLink to="/mail/account" className={linkClass}>
          <UserCircleIcon className="w-4 h-4 shrink-0" />
          Hesap
        </NavLink>
      </nav>
    </aside>
  );
};

export default MailSidebar;
